import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getGlovoPharmacyStatus = asyncActionsCreator(
  constants.GET_GLOVO_ENABLED_PHARMACY_STATUS
);
export const setEnableGlovoPharmacy = asyncActionsCreator(
  constants.SET_ENABLE_GLOVO_PHARMACY
);
export const setDisableGlovoPharmacy = asyncActionsCreator(
  constants.SET_DISABLE_GLOVO_PHARMACY
);
